export const ERRORS_ES = {
    Field_Required: 'Este campo es obligatorio.',
    Radio_Button_Required: 'Elija una opción para continuar.',
    Name_MinRequired: 'Ingrese al menos dos letras.',
    Name_ContainsNumbers: 'El nombre no puede contener números',
    Name_InvalidCharacters: 'Este campo no puede incluir el carácter especial que ha ingresado.',
    CC_NumberInvalid: 'Número de tarjeta inválido.',
    CC_AmexNotAccepted: 'No podemos aceptar American Express.',
    CC_ExpirationInvalidFormat: 'Ingrese una fecha de vencimiento válida. Ejemplo: MM/AAAA.',
    CC_ExpirationFutureDateRequired: 'La fecha de vencimiento debe ser en el futuro.',
    CVV_InvalidAmex: 'Ingrese cuatro dígitos exactamente.',
    CVV_InvalidNonAmex: 'Ingrese tres dígitos exactamente.',
    ACH_RoutingNumber_Invalid: 'El número de ruta debe tener al menos 9 dígitos.',
    ACH_AccountNumber_Invalid: 'Número de cuenta inválido.',
    ACH_AccountDescription_Required: 'Este campo es obligatorio.',
    ACH_AccountDescription_InvalidCharacters: 'Este campo no puede incluir el carácter especial que ha ingresado.',
    Address_StreetAddress_MinRequired: 'Ingrese al menos dos letras.',
    Address_StreetAddress_InvalidCharacters: 'Este campo no puede incluir el carácter especial que ha ingresado.',
    Address_StreetAddress2_InvalidCharacters: 'Este campo no puede  incluir el carácter especial que ha ingresado.',
    Address_City_MinRequired: 'Ingrese al menos tres letras.',
    Address_City_InvalidCharacters: 'Este campo no puede incluir el carácter especial que ha ingresado.',
    Address_State_InvalidSelection: 'Por favor, seleccione un Estado válido.',
    Address_Zip_FiveDigitsRequired: 'Ingrese cinco dígitos exactamente.',
    PostalCodeNonUS_InvalidCharacters: 'Este campo no puede incluir el carácter especial que ha ingresado.',
    PostalCodeNonUS_MinRequired: 'Introduzca al menos cuatro caracteres.',
};
//# sourceMappingURL=errors-es.js.map